import { PenIcon, TrashIcon } from "@xola/icons";
import { Badge } from "@xola/ui-kit";
import { isBefore, now, SecondaryButton } from "common";
import dayjs from "dayjs";
import { startCase } from "lodash";
import React from "react";
import { BaseSchedule, BaseScheduleType } from "types";
import { InlineConfirmDeletePopover } from "../Common/InlineConfirmDeletePopover";
import { useSeller } from "@/hooks/useAccount";

interface BaseScheduleButtonGroupProps {
    schedule: BaseSchedule;
    onDeleteSchedule: (schedule: BaseSchedule) => void;
    handleEditButton: (schedule: BaseSchedule) => void;
}

export const BaseScheduleButtonGroup = ({
    schedule,
    handleEditButton,
    onDeleteSchedule,
}: BaseScheduleButtonGroupProps) => {
    const { timezoneName } = useSeller();
    const { end: endScheduleDate } = schedule;

    const isExpired = endScheduleDate ? isBefore(dayjs(endScheduleDate).tz(timezoneName, true), now()) : false;

    return (
        <div className="flex items-center space-x-2">
            <Badge
                color={schedule.type === BaseScheduleType.AVAILABLE && !isExpired ? "success" : "danger"}
                data-testid="schedule-status"
            >
                {isExpired ? "Expired" : startCase(schedule.type)}
            </Badge>
            <SecondaryButton
                size="small"
                data-testid="base-schedule-input-edit-button"
                onClick={() => handleEditButton(schedule)}
            >
                <PenIcon />
            </SecondaryButton>

            <div>
                <InlineConfirmDeletePopover
                    placement="right"
                    confirmButtonText="Confirm"
                    onConfirm={async () => onDeleteSchedule(schedule)}
                >
                    <SecondaryButton size="small" data-testid="base-schedule-input-delete-button">
                        <TrashIcon />
                    </SecondaryButton>
                </InlineConfirmDeletePopover>
            </div>
        </div>
    );
};
